import React, { memo, SVGProps } from 'react'

export const ChevronUp = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.8832 13.7952C6.60192 14.0765 6.60192 14.5325 6.8832 14.8138C7.16448 15.095 7.62048 15.095 7.90176 14.8138L12.001 10.7136L16.1002 14.8138C16.3814 15.095 16.8374 15.095 17.1187 14.8138C17.2589 14.6736 17.3299 14.4893 17.3299 14.305C17.3299 14.1206 17.2598 13.9363 17.1187 13.7962L12.5107 9.1872C12.3754 9.05184 12.193 8.976 12.0019 8.976C11.8109 8.976 11.6275 9.05184 11.4931 9.1872L6.88512 13.7962L6.8832 13.7952Z"
      fill="currentColor"
    />
  </svg>
))
